import React from "react";
import Params from "../../../../componets/_params";
import WebCnCard from "./renders/CardRender";
import WebCnDevice from "./renders/DeviceRender";
import WebCnContractor from "./renders/ContractorRender";
import WebCnDocument from "./renders/DocumentRender";
import WebCnDate from "./renders/DateRender";
import WebCnDesc from "./renders/DescriptionRender";
import WebCnArticles from "./renders/Articlesrender";
import WebCnSummary from "./renders/SummaryRender";
import Resolvers from "../../../../componets/Api/internal/service/webcn";
import _placeholder from "../../../../componets/_placeholder";

class WebCn extends React.Component {
  timer;
  state = {
    _main: null,
    _articles: null,
    _files: null,
    _error: "",
    loading: false,
    sent: false,
    descChanged: false,
  };

  saveDesc = async (e) => {
    var _res = await Resolvers({
      ...this.props,
      SetDescData: true,
      webcn: { guid: this.props.params.id },
      data: e,
    });
  };

  writeDesc = (e) => {
    this.saveDesc(e);
    this.setState({ descChanged: false });
  };

  changeDesc = (e) => {
    let main = this.state._main;
    main[0] = { ...this.state._main[0], QuotationDesc: e };
    this.setState({ _main: main, descChanged: true });
    clearTimeout(this.timer);
    this.timer = setTimeout(() => this.writeDesc(e), 3000);
  };

  getData = async (id) => {
    this.setState({ loading: true, _error: "" });
    var _res = await Resolvers({
      ...this.props,
      GetData: true,
      webcn: { guid: id },
    });
    if (_res.status === 200)
      this.setState({
        loading: false,
        _main: JSON.parse(_res.data.main),
        _articles: JSON.parse(_res.data.articles),
        _files: JSON.parse(_res.data.files),
      });

    if (_res.status !== 200)
      this.setState({
        _error:
          "Nepovedlo se načíst data, ze zakázky. Zkontroluj, že zakázka je ve stavu WebCN (8856). Pokud se toto nevede ani při dalším pokusu tak změň něco v zakázce například dej mezeru do poznámky v záložce zákazník a zakázku ulož. Poté se vrať na tuto stránku a zmačni F5.",
      });
  };

  sentPriceProp = async (value, type, price, mainType) => {
    this.setState({ loading: true, _error: "" });
    var _res = await Resolvers({
      ...this.props,
      SentData: true,
      webcn: { guid: this.props.params.id, type: mainType },
      data: {
        commType: type,
        comm: value,
        totalPrice: price.toString(),
      },
    });

    if (_res.status === 200) {
      this.setState({
        loading: false,
        sent: true,
      });
    }

    if (_res.status !== 200) {
      this.setState({
        loading: false,
        sent: false,
        _error:
          "Něco se nepovedlo zkus obnovit CN a zkus to znovu. Je možné, že je zakázka v editaci na straně Servis21. Před odesláním CN musí být zakázka otevřená pro editaci.",
      });
    }
  };

  componentDidMount() {
    this.props.setHeaderPage({
      Icon: (
        <this.props._icon
          mdoutlinefilepresent
          className="c-placeholder c-green"
        />
      ),
      Title: "Cenová nabídka",
      SubTitle: "",
    });
    if (this.props.params.id && !this.state._main)
      this.getData(this.props.params.id);
  }

  render() {
    const { Bs, VARIANT, SIZE, _defaultImg } = this.props;
    return (
      <>
        {this.state.loading && (
          <>
            <Bs row>
              <Bs col>
                <Bs card bg={VARIANT.WHITE}>
                  <Bs cardbody>
                    {this.state._error === "" && (
                      <>
                        <Bs alert variant={VARIANT.WARNING}>
                          Probíhá načítání dat...
                        </Bs>
                        <_placeholder />
                      </>
                    )}
                  </Bs>
                </Bs>
              </Bs>
            </Bs>
          </>
        )}
        {this.state.sent && (
          <>
            <Bs row>
              <Bs col>
                <Bs card bg={VARIANT.WHITE}>
                  <Bs cardbody>
                    <Bs alert variant={VARIANT.SUCCESS}>
                      Cenový návrh byl úspěšně odeslán.
                    </Bs>
                  </Bs>
                </Bs>
              </Bs>
            </Bs>
          </>
        )}
        {this.state._error !== "" && (
          <>
            <Bs row>
              <Bs col>
                <Bs card bg={VARIANT.WHITE}>
                  <Bs cardbody>
                    <Bs alert variant={VARIANT.DANGER}>
                      {this.state._error}
                    </Bs>
                    <Bs row className="mt-4">
                      <Bs col className="d-flex justify-content-end">
                        <Bs
                          button
                          variant={VARIANT.SUCCESS}
                          size={SIZE.SM}
                          onClick={() => this.getData(this.props.params.id)}
                        >
                          Obnovit
                        </Bs>
                      </Bs>
                    </Bs>
                  </Bs>
                </Bs>
              </Bs>
            </Bs>
          </>
        )}
        {this.state._main &&
          !this.state.sent &&
          this.state._error === "" &&
          !this.state.loading && (
            <Bs row id="pdf-content">
              <Bs col xs={12}>
                <Bs div>
                  <Bs cardtitle className="ms-4 mt-4">
                    <Bs logo /> Cenová nabídka č. {this.state._main[0].DocNo}
                  </Bs>
                  <Bs cardbody>
                    <Bs row>
                      <WebCnCard {...this.props} dataCN={this.state._main} />
                      <WebCnContractor {...this.props} />
                      <WebCnDesc
                        {...this.props}
                        dataCN={this.state._main}
                        changeDescCn={(e) => this.changeDesc(e)}
                      />
                      <WebCnArticles
                        {...this.props}
                        dataCN={this.state._articles}
                        curr={this.state._main[0].InvoiceCurrCode}
                      />
                      <WebCnSummary
                        {...this.props}
                        curr={this.state._main[0].InvoiceCurrCode}
                        rate={this.state._main[0].InvoiceRate / 100 + 1}
                        dataNtf={{
                          value: this.state._main[0].comm,
                          label: this.state._main[0].commType,
                        }}
                        dataCN={this.state._articles}
                        sent={this.sentPriceProp}
                      />
                    </Bs>
                  </Bs>
                </Bs>
              </Bs>
            </Bs>
          )}
      </>
    );
  }
}

export default Params(WebCn);
